export default __webpack_public_path__ + "static/Agile-Medium-e11029ca3015d734bf0b26de09e055ef.ttf";